import myProductsDefaultHtml from "../myProducts/shops-views/default/myProducts.html";
import myProducts6Html from "../myProducts/shops-views/6/myProducts.html";
import "../myProducts/myProducts.component.scss";

class MyProductsController {
    constructor($scope, translateService) {
        'ngInject';
        this.$scope = $scope;
        this.translate = translateService;
    }

    $onInit() {
    }

    confirmDelete($event) {
        if (!confirm(this.translate.t('confirmDelete'))) {
            $event.preventDefault();
        }
    }
}

let MyProductsComponent = {
    bindings: {
        products: '<',
        shopId: '@'
    },
    template: `
        <div ng-if="$ctrl.shopId === '6'">
            ${myProducts6Html}
        </div>
        <div ng-if="$ctrl.shopId !== '6'">
            ${myProductsDefaultHtml}
        </div>
    `,
    controller: MyProductsController
};

export default MyProductsComponent;
